import {eventsSubject} from "./events";
import {filter} from "rxjs/operators";

export const OpenDemoDialogTopic = 'OpenDemoDialog';
export const OrderHoverOnMap = 'OrderHoverOnMap';
export const OrderHoverOutOnMap = 'OrderHoverOutOnMap';
export const OrderClickedOnMap = 'OrderClickedOnMap';
export const OrderHoverOnGrid = 'OrderHoverOnGrid';
export const OrderClickedOnGrid = 'OrderClickedOnGrid';
export const OrderHoverOutOnGrid = 'OrderHoverOutOnGrid';
export const FocusOrder = 'FocusOrder';
export const FocusMessengerActiveGroup = 'FocusMessengerActiveGroup';
export const GroupHoverOnGroupsToolbar = 'GroupHoverOnGroupsToolbar';
export const GroupHoverOutOnGroupsToolbar = 'GroupHoverOutOnGroupsToolbar';
export const GroupClickedOnGroupsToolbar = 'GroupClickedOnGroupsToolbar';
export const OrderClickedOnGroup = 'OrderClickedOnGroup';
export const NewOrder = 'NewOrder';
export const UpdateOrder = 'UpdateOrder';
export const DeleteOrder = 'DeleteOrder';
export const NewUser = 'NewUser';
export const UpdateUser = 'UpdateUser';
export const DeleteUser = 'DeleteUser';
export const NewAssignedGroup = 'NewAssignedGroup';
export const UpdateAssignedGroup = 'UpdateAssignedGroup';
export const DeleteAssignedGroup = 'DeleteAssignedGroup';
export const NewLockedGroup = 'NewLockedGroup';
export const UpdateLockedGroup = 'UpdateLockedGroup';
export const DeleteLockedGroup = 'DeleteLockedGroup';
export const FocusOrdersInMap = 'FocusOrdersInMap';

export const subscribe = (topic, callback) => eventsSubject.pipe(filter(f => f.topic === topic)).subscribe(callback);